/**
 * AllAll 图片 Seedream 4.0：POST /v1/images/generations（同步）
 * 模型 doubao-seedream-4-0-250828
 * 参数：model, prompt(必填), size(1K/2K/4K), sequential_image_generation=disabled, stream=false, response_format=url, watermark
 */
var MODEL = 'doubao-seedream-4-0-250828'

var SIZE_PRESETS = ['1K', '2K', '4K']

function normalizeSize(v) {
  if (!v || typeof v !== 'string') return '2K'
  var s = String(v).trim()
  if (SIZE_PRESETS.indexOf(s) !== -1) return s
  if (/^\d+x\d+$/.test(s)) return s
  return '2K'
}

/**
 * 构建 POST /v1/images/generations 的 JSON Body（Seedream 4.0）
 * @param {Object} params - prompt(必填), size/resolution(1K|2K|4K), addWatermark/watermark
 */
export function buildBody(params) {
  var prompt = (params.prompt || '').trim()
  if (!prompt) throw new Error('prompt 必填')
  var size = normalizeSize(params.size || params.resolution)
  var watermark = params.watermark !== undefined ? params.watermark : (params.addWatermark !== false)
  var body = {
    model: MODEL,
    prompt: prompt,
    size: size,
    sequential_image_generation: 'disabled',
    stream: false,
    response_format: 'url',
    watermark: !!watermark
  }
  return body
}
